import { formatCpfNumber } from "@app/dev/helpers/formatCpfNumber";

export const fields = [
  {
    name: 'cpf',
    fieldName: 'CPF Number',
    formatter: formatCpfNumber,
  },
  {
    name: 'firstName',
    fieldName: 'First Name',
    readOnly: true,
  },
  {
    name: 'lastName',
    fieldName: 'Last Name',
    readOnly: true,
  },
  {
    name: 'birthDate',
    fieldName: 'Birth Date',
    readOnly: true,
  },
];

export const basicFields = [{
  name: 'phoneNumber',
  fieldName: 'Phone',
},
{
  name: 'email',
  fieldName: 'Email',
},
{
  name: 'password',
  fieldName: 'Password',
  type: 'password',
},
{
  name: 'confirmPassword',
  fieldName: 'Confirm Password',
  type: 'password',
}];
